import React from "react";

import "./styles.css";

import isEmail from "validator/lib/isEmail";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome/index";

const USER_NAME_VALID =
  "https://ops-adduser.builtwithdark.com/validateUsername/";

const cocLink = "https://darklang.com/code-of-conduct";
class SignUp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      name: {
        value: "",
        error: null
      },
      email: {
        value: "",
        error: null
      },
      username: {
        value: "",
        error: null
      },
      inviter: "",
      agreeToCoc: {
        value: false,
        error: ""
      },
      showConfirmation: false,
      loading: false,
      error: ""
    };
  }

  componentDidMount() {
    if (this.props.token.length === 0) {
      this.setState({
        error: "This form is for invited users only"
      });
    }
  }

  validateName = () => {
    var regName = /^[a-zA-Z]+ [a-zA-Z]+$/;
    let name = this.state.name.value;
    let errMsg = null;
    if (name.length === 0) {
      errMsg = "Required field";
    } else if (!regName.test(name)) {
      errMsg = "Invalid name";
    }
    this.setState({
      name: { ...this.state.name, error: errMsg }
    });
    return errMsg === null;
  };

  validateEmail = () => {
    let email = this.state.email.value;
    let errMsg = null;
    if (email.length === 0) {
      errMsg = "Required field";
    } else if (!isEmail(email)) {
      errMsg = "Invalid email";
    }
    this.setState({
      email: { ...this.state.email, error: errMsg }
    });
    return errMsg === null;
  };

  validateUsername = async () => {
    let username = this.state.username.value;
    let errMsg = null;
    if (username.length === 0) {
      errMsg = "Required field";
    } else if (!/^[a-z][a-z0-9_]+[a-z0-9]$/.test(username)) {
      errMsg = "Invalid username";
    } else {
      const response = await fetch(USER_NAME_VALID + username, {
        method: "GET",
        dataType: "json",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        }
      });
      const json = await response.json();
      if (json !== 200) {
        errMsg = json;
      }
    }
    this.setState({
      username: {
        ...this.state.username,
        error: errMsg
      }
    });
    return errMsg === null;
  };

  validateCoc = () => {
    let agreeToCoc = this.state.agreeToCoc.value;
    this.setState({
      agreeToCoc: {
        ...this.state.agreeToCoc,
        error: agreeToCoc ? null : "Please agree to our code of conduct"
      }
    });
    return agreeToCoc;
  };

  renderFormFeild = (fieldName, placeholder, value, onChange, showInfo) => {
    return (
      <div className={"formField-wrapper " + placeholder}>
        <p className="error-text">{value.error || " "}</p>
        <div className="formField">
          {showInfo ? (
            <div className="field-txt">
              <p>{fieldName}</p>
              {this.renderUsernameReq()}
            </div>
          ) : (
            <p className="field-txt">{fieldName}</p>
          )}
          <input
            type="text"
            placeholder={placeholder}
            value={value.value}
            onChange={e => onChange(e.target.value)}
          ></input>
        </div>
      </div>
    );
  };

  updateFormField = (key, value) => {
    this.setState({
      [key]: { error: null, value }
    });
  };

  sendFormData = async () => {
    let data = {
      token: this.props.token,
      name: this.state.name.value,
      email: this.state.email.value,
      username: this.state.username.value
    };
    const response = await fetch(
      "https://ops-adduser.builtwithdark.com/create-account",
      {
        method: "POST",
        dataType: "json",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json"
        },
        body: JSON.stringify(data)
      }
    );
    const json = await response.json();
    if (json === 200) {
      this.setState({
        loading: false,
        showConfirmation: true
      });
    } else {
      this.setState({
        loading: false,
        error: json.error || null,
        name: { ...this.state.name, error: json.name || null },
        email: { ...this.state.email, error: json.email || null },
        username: { ...this.state.username, error: json.username || null }
      });
    }
  };

  async submitForm() {
    this.setState({
      loading: true,
      error: null
    });
    const validUsername = await this.validateUsername();
    const validName = this.validateName();
    const validEmail = this.validateEmail();
    const validCoc = this.validateCoc();
    const hasToken = this.props.token.length > 0;
    if (validName && validEmail && validCoc && validUsername && hasToken) {
      this.sendFormData();
    } else {
      this.setState({
        loading: false
      });
    }
  }

  renderUsernameReq = () => {
    return (
      <div className="info-icon-wrapper">
        <p className="username-req">
          Usernames must start with a letter and can only contain lowercase
          alphanumeric characters and underscores. <br />
          We reserve the right to close accounts with usernames containing
          inappropriate content such as racial slurs or derogatory language. We
          also reserve the right to close accounts with usernames that look as
          though they are attempting to impersonate Dark employees or potential
          services.
        </p>
        <FontAwesomeIcon className="info-icon" icon="question-circle" />
      </div>
    );
  };

  render() {
    if (this.state.showConfirmation) {
      return (
        <div className="confirmation-screen">
          <h1 className="light-purple center-text">
            Congratulations! You are now a member of the Dark private beta.
            Please check your email to finish setting up your account.
          </h1>
        </div>
      );
    } else {
      return (
        <div className="signup-container">
          <div className="signup-form">
            <h1>Sign up</h1>
            <h3 className="subtext center-text">
              Thank you for your interest in Dark's private beta! We're excited
              to get you set up and hear what you think.
            </h3>
            <h3 className="error">{this.state.error}</h3>
            {this.renderFormFeild(
              "Name:",
              "name",
              this.state.name,
              this.updateFormField.bind(this, "name")
            )}
            {this.renderFormFeild(
              "Email:",
              "email",
              this.state.email,
              this.updateFormField.bind(this, "email")
            )}
            {this.renderFormFeild(
              "Username:",
              "username",
              this.state.username,
              this.updateFormField.bind(this, "username"),
              true
            )}
            <div className="checkbox-wrapper">
              <p className="error-text">{this.state.agreeToCoc.error || ""}</p>
              <div className="checkbox-field">
                <input
                  type="checkbox"
                  onChange={() =>
                    this.updateFormField(
                      "agreeToCoc",
                      !this.state.agreeToCoc.value
                    )
                  }
                  value={this.state.agreeToCoc.value}
                ></input>
                <p>
                  I promise to abide by the{" "}
                  <a target="_blank" rel="noopener noreferrer" href={cocLink}>
                    Code of Conduct
                  </a>{" "}
                  when using Dark services or participating in the Dark Slack
                  community.
                </p>
              </div>
            </div>
            {this.state.loading ? (
              <div className="submit-btn">
                <FontAwesomeIcon
                  className="white-text spinner"
                  icon="spinner"
                  spin
                />
                <p>Loading</p>
              </div>
            ) : (
              <div
                onClick={() => {
                  this.submitForm();
                }}
                className="submit-btn"
              >
                <p>Create Account</p>
              </div>
            )}
          </div>
        </div>
      );
    }
  }
}

export default SignUp;
